
import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../interfaces/app-state.interface';
import { LoginWraperService } from '../services/login.wraper.service';
import { SettingsService } from '../services/settings/settings.service';
import { UsersState } from '../state-management/users/users.reducer';

@Injectable()
export class LoggedDomainGuard implements CanActivate, CanActivateChild {

    private usersState: UsersState;
    private authentication$: Observable<UsersState>;

    constructor(
        private store: Store<AppState>,
        private loginWraperService: LoginWraperService,
        private settingsService: SettingsService,
        ) {

        this.authentication$ = this.store.select((state) => state.authentication);
        this.authentication$.subscribe((authState) => this.usersState = authState);
    }

    // Método de Interface
    public canActivate() {
        return this.canActivateGeneral();
    }

    public canActivateChild() {
        return this.canActivateGeneral();
    }

    public canActivateGeneral() {
        const userHasSession = this.usersState.currentUser &&
        this.usersState.currentUser.token;

        if (userHasSession || !this.settingsService.isOnLoggedDomain()) {
            return true;
        }

        this.loginWraperService.navigateToLogin({
            afterLoginRedirectTo: `${window.location.pathname}${window.location.search}`,
        });
        return false;

    }
}
